module.exports = __webpack_public_path__ + "img/button-google-play-color.ab535cd2.png";